import React, { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loader from 'wrapper/loader';

const Login = lazy(() => import('@/pages/shared/auth/login/Login'));
const LoanInformation = lazy(() => import('@/pages/b2b/loan-management/loan-information'));
const NotFound = lazy(() => import('components/404'));
const BorrowerProfile = lazy(() => import('@/pages/b2b/loan-management/borrower-profile'));
const PipelineAdmin = lazy(() => import('@/pages/b2b/pipeline'));
const Admin = lazy(() => import('@/pages/b2b/admin'));
const AdminInvitations = lazy(() => import('@/pages/b2b/admin/invitations'));
const Dashboard = lazy(() => import('@/pages/b2b/dashboard'));
const Reports = lazy(() => import('@/pages/b2b/reports/reports'));
const Tools = lazy(() => import('@/pages/b2b/tools'));
const QuickPrice = lazy(() => import('@/pages/b2b/loan-management/quick-price'));
const HelpSupport = lazy(() => import('@/pages/shared/help-support'));
const CompanyOnboarding = lazy(() => import('@/pages/b2b/onboarding/CompanyOnboarding'));
const DocumentPage = lazy(() => import('@/components/document-viewer/DocumentPage'));

const suspenseFallback = <Loader />;

const adminRoutes = [
  {
    path: '/',
    element: (
      <Suspense fallback={suspenseFallback}>
        <Login />
      </Suspense>
    ),
    children: [
      {
        path: 'onboard',
        element: (
          <Suspense fallback={suspenseFallback}>
            <CompanyOnboarding />
          </Suspense>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Dashboard />
          </Suspense>
        ),
        children: [],
      },
      {
        path: 'loanInformation',
        element: (
          <Suspense fallback={suspenseFallback}>
            <LoanInformation />
          </Suspense>
        ),
        children: [],
      },
      {
        path: ':param/lead',
        element: (
          <Suspense fallback={suspenseFallback}>
            <BorrowerProfile />
          </Suspense>
        ),
      },
      {
        path: 'pipeline',
        element: (
          <Suspense fallback={suspenseFallback}>
            <PipelineAdmin />
          </Suspense>
        ),
      },
      {
        path: 'reports',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Reports />
          </Suspense>
        ),
        children: [],
      },
      {
        path: 'tools',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Tools />
          </Suspense>
        ),
      },
      {
        path: 'quickPrice',
        element: (
          <Suspense fallback={suspenseFallback}>
            <QuickPrice />
          </Suspense>
        ),
      },
      {
        path: 'help-support',
        element: (
          <Suspense fallback={suspenseFallback}>
            <HelpSupport />
          </Suspense>
        ),
      },
      {
        path: 'admin',
        index: true,
        element: <Navigate to="admin/employees" replace />,
      },
      {
        path: 'admin/employees',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Admin />
          </Suspense>
        ),
      },
      {
        path: 'admin/branches',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Admin initialTab="branches" />
          </Suspense>
        ),
      },
      {
        path: 'admin/invitations',
        element: (
          <Suspense fallback={suspenseFallback}>
            <AdminInvitations />
          </Suspense>
        ),
      },
      {
        // One document in a tab of its own, opened from the document viewer.
        // Login renders it without the app shell.
        path: 'document/:documentId',
        element: (
          <Suspense fallback={suspenseFallback}>
            <DocumentPage />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: (
          <Suspense fallback={suspenseFallback}>
            <NotFound />
          </Suspense>
        ),
      },
    ],
  },
];

export default adminRoutes;
